const DatabaseTables = {
  draftOrderTable: "draftOrderList"
}

export default DatabaseTables
